import { render, staticRenderFns } from "./VuetifyLayout.vue?vue&type=template&id=b835380a&"
import script from "./VuetifyLayout.vue?vue&type=script&lang=js&"
export * from "./VuetifyLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports